import { Label } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingPromoLabelProps {
  texts: string[];
}

export const MortgagedPropertyLabels: React.FC<INewbuildingPromoLabelProps> = ({ texts }) => {
  return (
    <div className={styles['container']}>
      {texts.map((text, index) => (
        <div className={styles['label']} key={index}>
          <Label color="black_100" background="gray6_100">
            {text}
          </Label>
        </div>
      ))}
    </div>
  );
};
